import { combineReducers } from "redux";
import * as Reducers from "../ducks/reducers";

export default combineReducers(Reducers);
